import { render } from "./PaymentSuccess.vue?vue&type=template&id=33a81294"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__